import { IFeature } from 'mod/featureV2/interface';

export const article: IFeature = {
    moduleId: 'article',
    type: 'article',
    space: {
        marginTop: 0,
        marginBottom: 0,
    },
    config: {
        baseFontSize: 14,
        lineHeight: 1.286,
    },
    list: [
        '<strong style="font-size: 1.143em">Return Policy for Free Gifts:</strong>',
        `1. The Gift Box provided with a VGrow purchase cannot be returned separately under any circumstances.<br>
        2. VGrow may be returned within 30 days of delivery. If the Gift Box was received, it must be returned along with the VGrow product.<br>
        3. Except for quality issues, returns must be unused with all original tags and packaging. Used or damaged items cannot be returned or refunded.`,
    ]
};